module.exports = __webpack_public_path__ + "img/6E8C48_B8CDA7_344018_A8BC94-256px.78443f2d.png";